
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.64 11c.907 0 1.693-.333 2.36-1 .667-.667 1-1.453 1-2.36 0-.907-.333-1.68-1-2.32-.667-.64-1.453-.96-2.36-.96-.907 0-1.68.32-2.32.96a3.16 3.16 0 00-.96 2.32c0 .907.32 1.693.96 2.36.64.667 1.413 1 2.32 1zM29.36 1c.453 0 .84.16 1.16.48.32.32.48.707.48 1.16v10c0 .453-.16.853-.48 1.2-.32.347-.707.52-1.16.52H2.64c-.453 0-.84-.173-1.16-.52a1.716 1.716 0 01-.48-1.2v-10c0-.453.16-.84.48-1.16.32-.32.707-.48 1.16-.48h26.72zM7.64 27.64c.907 0 1.693-.32 2.36-.96.667-.64 1-1.413 1-2.32 0-.907-.333-1.693-1-2.36-.667-.667-1.453-1-2.36-1-.907 0-1.68.333-2.32 1-.64.667-.96 1.453-.96 2.36 0 .907.32 1.68.96 2.32.64.64 1.413.96 2.32.96zm21.72-10c.453 0 .84.167 1.16.5.32.333.48.74.48 1.22v10c0 .453-.16.84-.48 1.16-.32.32-.707.48-1.16.48H2.64c-.453 0-.84-.16-1.16-.48A1.58 1.58 0 011 29.36v-10c0-.48.16-.887.48-1.22.32-.333.707-.5 1.16-.5h26.72z"}})])
          )
        }
      }
    